import { render, staticRenderFns } from "./AcceptQuote.vue?vue&type=template&id=0bfe5084&scoped=true&"
import script from "./AcceptQuote.vue?vue&type=script&lang=js&"
export * from "./AcceptQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe5084",
  null
  
)

export default component.exports